<template>
  <div class="settlementShop" style="margin-top: 220px;">
    <div class="shop-carBox comWidth">

      <!--配送方式-->
<!--      <div>
        <h4 class="shop-formTitle"><span class="red">*</span>配送方式</h4>
        <el-radio-group v-model="orderInformation.deliver_method">
          <el-radio :label="0">商城配送</el-radio>
          <el-radio :label="1">门店自提</el-radio>
        </el-radio-group>
      </div>-->

      <!--选择自提点-->
    <!--  <div v-if="orderInformation.deliver_method==1">
        <h4 class="shop-formTitle"><span class="red">*</span>选择自提点</h4>
        <div>
          <div>
            <span>选择省市区 : </span>
            <el-cascader
              size="large"
              :options="optionsZ"
              v-model="selectedOptionsZ"
              @change="handleChangeZ">
            </el-cascader>
            <el-button type="danger">蒐索</el-button>
          </div>
          <div class="storeAndMsg">
            <span>门店 :&nbsp; </span>
            <el-col :span="12">
              <el-autocomplete
                class="inline-input"
                v-model="orderInformation.store_id"
                :fetch-suggestions="querySearch"
                placeholder="请输入内容"
                @select="handleSelect"
              ></el-autocomplete>
            </el-col>
          </div>
          <p class="addr">
            <span>地址 ： </span>
            <span>澳门威尼斯人酒店一层1044号（威尼斯人剧场旁）</span>
          </p>
        </div>
      </div>-->

      <!--收件人信息-->
      <div class="recipients_box">
        <h4 class="shop-formTitle"><span class="red">*</span>收件人信息</h4>
        <!--商城配送收件人信息-->
        <ul>
          <li data-shipping="1" v-for="(item, i) in obta" @click="setDefault(item,i)"  :key='item.id' :class="{ on: item.is_default == 1 }">
            <div class="word-box">
              <h5>收貨人：{{item.consignee}}
                <span class="tel">聯系電話：{{item.tel}}</span>
              </h5>
              <p>收貨地址：{{item.province}}{{item.city}}{{item.district}}{{item.address}}</p>
              <div class="operation">
                <div class="operation">
                  <el-button
                    size="mini"
                    type="danger"
                    @click="deleteData(item)"  v-on:click.stop="doThis">删除</el-button>
                  <el-button
                    size="mini"
                    @click="modifyAdd()" v-on:click.stop="doThis" >修改</el-button>
                </div>
              </div>
            </div>
          </li>
          <!--add-->
          <div class="add" @click="newAddress"><i class="el-icon-plus"></i><p>新增地址</p></div>
        </ul>
<!--
        &lt;!&ndash;门店自提收货人信息&ndash;&gt;
        <div v-if="orderInformation.deliver_method==1">
          <el-form :inline="true" :model="formInline" class="demo-form-inline">
            <el-form-item label="收货人">
              <el-input v-model="formInline.user" placeholder="收货人"></el-input>
            </el-form-item>
            <el-form-item label="联系电话">
              <el-input v-model="formInline.tel" placeholder="联系电话" type="tel"></el-input>
            </el-form-item>
          </el-form>
        </div>-->
      </div>

      <!--商品列表-->
      <div>
        <h4 class="shop-formTitle">商品列表</h4>
        <el-table
          :data="purchaseData"
          style="width: 100%">
          <el-table-column
            prop="goods_name"
            label="商品信息"
            width="180">
          </el-table-column>
          <el-table-column
            label="發貨倉"
            width="180">
            <template  slot-scope="scope">離境仓</template>
          </el-table-column>
          <el-table-column
            label="本倉稅費"
            width="180">
            <template  slot-scope="scope">￥0.00</template>
          </el-table-column>
          <!--<el-table-column-->
            <!--prop="specifications"-->
            <!--label="规格">-->
          <!--</el-table-column>-->
          <el-table-column
            prop="price"
            label="單價（元）">
          </el-table-column>
          <el-table-column
            prop="num"
            label="數量">
          </el-table-column>
          <el-table-column
            prop="smallPlan"
            label="金額（元）">
          </el-table-column>
        </el-table>
      </div>

      <!--訂單備註-->
      <div class="msg">
        <h4 class="shop-formTitle">訂單備註</h4>
        <div class="bor">
          <el-input
            type="textarea"
            v-model="orderInformation.remark"
            :autosize="{ minRows: 2, maxRows: 4}"
            placeholder="請輸入您的訂單備註信息">
          </el-input>
        </div>
      </div>

      <!--優惠選擇-->
      <div class="adviser" v-if="myCouponsList.length != 0 || shoppingFullList.length != 0 || totalIntegral != 0">
        <h4 class="shop-formTitle">優惠選擇</h4>
        <div class="redEnvelope">
          <el-form :inline="true" class="demo-form-inline">
            <el-form-item label="積分使用" style="display: block;" label-width="100px" v-if="integralRule.min != undefined && integralRule.max != undefined && integralRule.amount != undefined">
              <el-input v-model="use_points" :min="integralRule.min" :max="integralRule.max" @input="usePoints" placeholder="請輸入需要使用的積分" type="number"></el-input>
            </el-form-item>
            <el-form-item style="display: block;" v-if="isJiFen">
              <template>
                <div class="limit">
                  <span>當前積分: </span><span>{{totalIntegral}}</span><span class="mar">|</span>
                  <span>單筆訂單最少可使用: </span><span>{{integralRule.min}}</span><span class="mar">|</span>
                  <span>單筆訂單最多可使用: </span><span>{{integralRule.max}}</span><span class="mar">|</span>
                  <span>單筆訂單金額門檻: </span><span>{{integralRule.amount}}</span>
                </div>
              </template>
            </el-form-item>
      <!--      <el-form-item label="單筆訂單最少可使用:">
              <template>
                <span>{{integralRule.min}}</span>
              </template>
            </el-form-item>
            <el-form-item label="單筆訂單最多可使用:">
              <template>
                <span>{{integralRule.min}}</span>
              </template>
            </el-form-item>
            <el-form-item label="單筆訂單金額門檻:"  style="display: block;">
              <template>
                <span>{{integralRule.amount}}</span>
              </template>
            </el-form-item>-->
       <!--     <el-form-item label="活動選擇" label-width="100px" style="display: block;">
              <template>
                <el-select v-model="valueS" placeholder="请选择" @input="useRed">
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </template>
            </el-form-item>
            <el-form-item label="優惠券選擇" label-width="100px"  style="display: block;">
              <template>
                <el-select v-model="valueS" placeholder="请选择" @input="useRed">
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </template>
            </el-form-item>-->
            <el-form-item label="優惠活動選擇" label-width="100px"  style="display: block;" class="pa0"  v-if="myCouponsList.length != 0 || shoppingFullList.length != 0">
        <!--      <el-cascader
                placeholder="选择需要参与的活动"
                :options="activity"
                filterable
                :props="props"
                show-all-levels
                @change="choiceActivities()"
              ></el-cascader>-->
              <el-radio-group v-model="radioX" @change="choice">
                <el-radio :label="1" v-if="myCouponsList.length > 0">优惠券</el-radio>
                <el-radio :label="2" v-if="shoppingFullList.length > 0">满减活动</el-radio>
              </el-radio-group>
                <el-select v-model="valueS" placeholder="请选择优惠券"  @clear="clearNum"  @change="useRed()" v-if="radioX == 1" clearable>
                  <el-option
                    v-for="item in myCouponsList"
                    :key="item.id"
                    :label="item.coupon_name"
                    :value="item.id">
                    <template> 满&yen;{{item.pay}}可使用（&yen;{{item.worth}}）</template>
                  </el-option>
                </el-select>
                <el-select v-model="valueS" placeholder="请选择满减活动" v-if="radioX == 2" @clear="clearNum" @change="useRed()" clearable>
                  <el-option
                    v-for="item in shoppingFullList"
                    :key="item.id"
                    :label="item.reduction_name"
                    :value="item.id">
                    <template> 满&yen;{{item.worth.pay}}减 &yen;{{item.worth.worth}}</template>
                  </el-option>
                </el-select>
            </el-form-item>
          </el-form>
        </div>
      </div>

      <!--选择顾问-->
      <div class="adviser" v-if="is_server == 1">
          <h4 class="shop-formTitle">顧問選擇</h4>
        <el-form>
          <el-form-item label="選擇地區">
            <el-cascader
              size="large"
              :options="options"
              change-on-select
              v-model="selectedOptions"
              @change="handleChangeSearch">
            </el-cascader>
          </el-form-item>
          <el-form-item label="選擇顧問">
            <el-select v-model="orderInformation.counselor_id" placeholder="请选择">
              <el-option v-for="item in optionS"
                         :key="item.id"
                         :label="item.real_name +'     '+ (item.phone == '' ? '':(item.phone).replace(((item.phone)).substring(3,7),'****'))  "
                         :value="item.counselor_id">
                <span style="float: left; color: #8492a6; font-size: 13px">{{ item.real_name }}</span>
                <span style="float: right">{{ item.phone == '' ? '':(item.phone).replace(((item.phone)).substring(3,7),'****')}}</span>
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>

   <!--     <h4 class="shop-formTitle">顧問選擇</h4>
        <div class="storeAndMsg">
          <span>顧問 :&nbsp; </span>
          <el-select filterable remote reserve-keyword clearable placeholder="請輸入顧問名字或者電話"
                     v-model="orderInformation.counselor_id" :remote-method="remoteMethod" :loading="loading">
            <el-option v-for="item in optionS"
                       :key="item.id"
                       :label="item.real_name +'     '+ (item.phone == '' ? '':(item.phone).replace(((item.phone)).substring(3,7),'****'))  " :value="item.id">
              <span style="float: left; color: #8492a6; font-size: 13px">{{ item.real_name }}</span>
              <span style="float: right">{{ item.phone == '' ? '':(item.phone).replace(((item.phone)).substring(3,7),'****')}}</span>
            </el-option>
          </el-select>
        </div>-->
      </div>


      <!--小貼士-->
      <div class="information_main">
        <div class="_main">
          <div class="_left">
            小貼士：<br>
            1.受限於銀行支付額度的相關規定，您可能會遇到銀行支付限額低於訂單金額而無法成功購買的情況。為了方便您購買，您可以根據銀行支付限額的要求，將您的大額訂單拆分為多個訂單進行購買。<a href="../../../static/wechat_limit_2017.pdf" target="_blank">《微信支付限額表》</a><a href="../../../static/bank_limit_2017.pdf" target="_blank">《銀聯支付限額》</a><br>
            2.如果您想盡快支付訂單完成購買，您還可以撥打+86 400-061-3311查詢離您最近的服務門店尋求幫助。
          </div>
          <div class="_right">
            <div>
              <p><b>商品應付總計：</b><span>￥{{totalPrice}}</span></p>
              <p><b>運費：</b><span>￥0.00</span></p>
              <p><b>稅費：</b><span>￥0.00</span></p>
              <p><b>積分抵扣：</b><span class="huodongyouhui">￥{{orderInformation.use_points}}</span></p>
              <p><b>活動抵扣：</b><span class="huodongyouhui">￥{{this.worth.reduce}}</span></p>
              <p><b>應付金額：</b><span class="yingfu">￥{{preferentialPrice}}</span></p>
            </div>
            <button type="button" class="btn btn-primary" @click="submissionOrder">提交訂單</button>
            <!--<button type="button" class="btn btn-primary" @click="privateStore" v-if="orderInformation.deliver_method==1">提交訂單</button>-->
          </div>
        </div>
      <label >
        <input type="checkbox" v-model="agree" name='qued' @click="a=true">本人同意並接受
        <router-link :to="{name:'Agreement',query:{id:4}}" class="userXie" tag="a">《進口個人委托申報委托》</router-link>
      </label>
    </div>
  </div>
    <!--导航-->
    <NavB :titleChild="titleChild"/>
    </div>
</template>

<script>
  import NavB from '@/pages/detailsPage/NavB'
  //pdf
  import pdf from 'vue-pdf'
  //adress
  import { regionData  , CodeToText ,TextToCode} from 'element-china-area-data'
  //common.js
  import {getLocalStorage,setLocalStorage , ifSignIn} from '@/utils/common';
  //api
  import {addAddress , modifyAddress , deleteAddress , obtainAddress} from '@/api/address';
  import {placeOrder} from '@/api/order';
  import {counselors, pointRule} from '@/api/other';
  import {userInformation} from '@/api/authentication';
//  import {journalismDetails} from '@/api/article';
  import {isMyCoupons,shoppingFull} from '@/api/activity';
  import { Loading } from 'element-ui';
  export default {
    name: 'SettlementShop',
    components:{
      NavB,
    },
    data () {
      return {
        options: regionData,
        selectedOptions: [],
        radioX:0,
        currentIndex: null,
        titleChild:[{name:'首頁',src:'HomePage'},{name:'購物車',src:'ShoppingCart'}],
        //购物车数据
        num1:1,
        tableData: [{
          information: '極草·5X冬蟲夏草純粉片（經典含片）0.25克/片×60片/瓶	',
          warehouse: '離境仓',
          taxation: '￥0.00',
          specifications: '',
          unitPrice: '12228.00',
          num: 'x1',
          totalPrice: '￥25278.00'
        }],
//        options: [{
//          value: '100',
//          label: '100'
//        }, {
//          value: '200',
//          label: '200'
//        }, {
//          value: '300',
//          label: '300'
//        }, {
//          value: '400',
//          label: '400'
//        }, {
//          value: '500',
//          label: '500'
//        }],
        valueS: '',
        //立即购买数据
        purchaseData:[],
        //总价
        totalPrice:'0.00',
        //活动抵扣
        discount:'0.00',
        //优惠后的总价
        preferentialPrice:'0.00',
//        //积分抵扣
//        usePoint:'0.00',
        //所有收货地址
        obta:null,
        //是否同意並接受 《進口個人委托申報委托》
        agree:false,
        //订单收货地址
//        OrderReceipts:'',
        orderInformation:{
          consignee:'',//收货人
          province:'',//省份
          city:'',//城市
          district:'',//区
          address:'',//详细地址
          deliver_method:0,//配送方式
          shopping_cart:[],//购物车数据
          remark:'',//订单备注
          counselor_id:'',//顾问
//          store_id:'',//提货门店
          use_points:0,//使用积分
          promotion:this.$route.query.gift || undefined,// 大礼包 满减 优惠券name
          promotion_id:this.$route.query.id || undefined,// 大礼包 满减 优惠券id
        },
        use_points:0,//使用积分
        //门店自提 地址搜索
        optionsZ: regionData,
        selectedOptionsZ: [],
        modifyData:[],
        //自提收货人联系方式
//        formInline: {
//          user: '',
//          tel: ''
//        }
        list: [],
        loading: false,
        restaurants:[],
        optionS: [],
        //协议id
        articleData:{
          article:'90',
          include:'articlecat'
        },
        //协议列表
        agreement:'',
        //积分规则
        integralRule:{
          max:0,
          min:0,
          amount:0
        },
        //总积分
        totalIntegral:0,
        // 余额
        user_money:0,
        isJiFen:false,
        // 活动
        activity:[
          {
            label: '商城滿减',
            name:[]
          },
          {
            label: '優惠券',
            name:[]
          }
        ],
        props: {
          value: 'label',
          children: 'name'
        },
        // 优惠券
        myCouponsList:[],
        // 满减活动
        shoppingFullList:[],
        worth:{
          full:0, // 满
          reduce:0, // 减
        },
        goods:[], // 获取满减活动 优惠券 所需参数
        user_id:undefined, // 用户id
        point:0, // 积分
        is_server:0, // 判断是否可以选择顾问
        is_counselor:undefined, // 判断是否可以余额支付
        counselorsForm:{ // 顾问地区
//          real_name:undefined,
          province_code:undefined,
          city_code:undefined,
          district_code:undefined,
        },
      }
    },
    methods:{
      doThis:function () { // 阻止事件的传播
      },
      handleChangeSearch (value) {
        this.counselorsForm.province_code = value[0]
        this.counselorsForm.city_code = value[1]
        this.counselorsForm.district_code = value[2]
        this.getCounselors(this.counselorsForm);
      },
      /*获取登陆后的个人信息*/
      getInformation(){
        userInformation().then(res =>{
          this.user_id = res.data.id;
          this.totalIntegral = res.data.user_points;
          this.user_money = res.data.user_money;
          this.is_server = res.data.is_server;
          this.is_counselor = res.data.is_counselor;
          sessionStorage.setItem('is_counselor',res.data.is_counselor)
          sessionStorage.setItem('surplus',res.data.user_money)
          //获取商品参数
          this.getParams()
          //获取满减活动
          this.getMyCouponsList(this.point)
          //获取已经拥有的优惠券
          this.getShoppingFullList(this.point)
        })
      },

        //地址删除
      deleteData(row) {
        this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          lockScroll:false,
          type: 'warning'
        }).then(() => {
          deleteAddress(row.id).then(res =>{
            console.log(res);
            this.displayAddress();
            this.$message.success('删除成功');
          })
        }).catch(() => {
          this.$message.info('已取消删除');
        });
        this.displayAddress();
      },

      handleChange(value) {
        console.log(value);
      },

      /*自提门店地址*/
      handleChangeZ (value) {
        this.modifyData.province = CodeToText[value[0]];
        this.modifyData.city = CodeToText[value[1]];
        this.modifyData.district = CodeToText[value[2]];
        console.log(this.modifyData)
      },

      //地址修改
      modifyAdd(){
        this.displayAddress();
        this.$router.push({
          name:'ShopAddress'
        })
      },

      /*获取立即购买数据*/
      getImmediately(){
        getLocalStorage('purchaseData' ,  (res)=>{
          this.purchaseData = res;
        }) ;
        getLocalStorage('price' ,  (res)=>{
          this.totalPrice = res;
          this.preferentialPrice = res;
        })
      },

      /*清除所选活动*/
      clearNum(){
        this.valueS = ''
        this.worth = {
          full:0, // 满
          reduce:0 // 减
        }
        if(this.orderInformation.promotion == 'gift'){
          this.orderInformation.promotion = this.$route.query.gift
          this.orderInformation.promotion_id = this.$route.query.id
        } else {
          this.orderInformation.promotion = undefined
          this.orderInformation.promotion_id = undefined
        }
        this.preferentialPrice = (parseFloat(this.totalPrice) - parseFloat(this.orderInformation.use_points) - this.worth.reduce ).toFixed(2)
      },

      /*使用活动*/
      useRed(){
        console.log(this.valueS)
//        var _id = (this.valueS).split(this.valueS[(this.valueS).lastIndexOf('/')])
        var _ID = this.valueS
        if(this.orderInformation.promotion == 'gift'){
          this.$message.warning('您已參加大禮包活動，不能再參與其他活動')
          return false
        } else {
          if(this.radioX == 1){ //优惠券
            this.myCouponsList.forEach(it =>{
              if(it.id == _ID){
                this.worth.full = parseFloat(it.pay)
                this.worth.reduce = parseFloat(it.worth)
                this.orderInformation.promotion = 'coupon'
                this.orderInformation.promotion_id = it.id
              }
              return [this.worth,this.orderInformation]
            })
          } else if(this.radioX == 2) { // 满减
            this.shoppingFullList.forEach(it =>{
              if(it.id == _ID){
                this.worth.full = parseFloat(it.worth.pay).toFixed(2)
                this.worth.reduce = parseFloat(it.worth.worth).toFixed(2)
                this.orderInformation.promotion = 'reduction'
                this.orderInformation.promotion_id = it.id
              }
              return [this.worth,this.orderInformation]
            })
          }
          // 判断是否能使用优惠券和参与满减活动
          if(parseFloat(this.totalPrice) < this.worth.full){
            this.$message.warning('您還未達到使用活動門檻')
            this.worth = {
              full:0, // 满
              reduce:0, // 减
            }
            return false
          } else{
            this.preferentialPrice = (parseFloat(this.totalPrice) - parseFloat(this.orderInformation.use_points) - this.worth.reduce ).toFixed(2)
          }
          console.log(this.worth)
        }

        // this.discount = (parseFloat(this.valueS)).toFixed(2)
        // this.preferentialPrice = (parseFloat(this.totalPrice) - parseFloat(this.valueS) - parseFloat(this.usePoint)).toFixed(2)
      },

      /*积分使用*/
      usePoints(){
        if(this.orderInformation.promotion == 'gift'){
          this.$message.warning('您已參加大禮包活動，不能再使用積分')
          this.calculation()
          return false
        }
        this.isJiFen = true
        if(this.use_points == ''){
          this.use_points = 0
        }
        if(this.valueS == ''){
          this.valueS = 0
        }
        if(parseFloat(this.use_points) > parseFloat(this.integralRule.max)){
          this.$message.warning('當前訂單最多可使用積分' + '    ' + this.integralRule.max)
          this.calculation()
        }
        else if(parseFloat(this.use_points) > parseFloat(this.totalIntegral)){
          this.$message.warning('使用積分不能超過當前總積分' + '    ' + this.totalIntegral)
          this.calculation()
        }
        else if(parseFloat(this.use_points) < parseFloat(this.integralRule.min)){
          this.$message.warning('使用積分不能低于单笔最少使用积分' + '    ' + this.integralRule.min)
          this.calculation()
        }
        else if(parseFloat(this.totalPrice) < parseFloat(this.integralRule.amount)){
          this.$message.warning('當前訂單為達到積分使用最低門檻' + '    ' + this.integralRule.amount)
          this.calculation()
        }
        else {
          this.point = (parseFloat(this.use_points)).toFixed(2)
          //获取满减活动
          this.getMyCouponsList(this.point)
          //获取已经拥有的优惠券
          this.getShoppingFullList(this.point)
          this.orderInformation.use_points = (parseFloat(this.use_points)).toFixed(2)
          this.preferentialPrice = (parseFloat(this.totalPrice) - parseFloat(this.worth.reduce) - parseFloat(this.orderInformation.use_points)).toFixed(2)
        }
      },
      /*积分计算*/
      calculation(){
        this.orderInformation.use_points = 0
        this.preferentialPrice = (parseFloat(this.totalPrice) - parseFloat(this.worth.reduce) - parseFloat(this.orderInformation.use_points)).toFixed(2)
      },

      /*新增收货地址*/
      newAddress(){
        this.$router.push({
          name:'ShopAddress'
        })
      },

      /*获取收货地址*/
      displayAddress(){
        //获取所有收货地址
        obtainAddress().then(res =>{
          this.obta = res.data.data;
          this.setUp()
          console.log(this.obta)
        })
      },

      /*设为默认地址*/
      setDefault(item,index){
 /*         this.currentIndex = index;
          this.orderInformation.consignee = item.consignee;
          this.orderInformation.province = item.province;
          this.orderInformation.city = item.city;
          this.orderInformation.district = item.district;
          // this.orderInformation.district = item.district;
          this.orderInformation.address = item.address;
          this.orderInformation.tel = item.tel;
          console.log(item)*/
        var def = {
          is_default:1,
          id:item.id
        };
        console.log( def)
        modifyAddress(def).then( res =>{
          this.$message.success('設定成功');
          this.displayAddress();
        })
      },

      /*获取默认数据*/
      setUp(){
        this.obta.forEach((item,idx) =>{
            if(item.is_default == 1){
              this.orderInformation.consignee = item.consignee;
              this.orderInformation.province = item.province;
              this.orderInformation.city = item.city;
              this.orderInformation.district = item.district;
              this.orderInformation.address = item.address;
              this.orderInformation.tel = item.tel;
              this.currentIndex = item
            }
            return [this.orderInformation,this.currentIndex]
        })
      },

      /*商城配送提交订单*/
      submissionOrder(){
        ifSignIn(this, () =>{
            if(this.purchaseData.length == 0){
              this.$message.warning('暫時沒有可提交的訂單哦');
              setTimeout( ()=> {
                this.$router.push({name:'ProductPage'});
              },1000)
            }else {
              if (this.agree === false){
                this.$alert('请选择委託協議', '委託協議', {
                  confirmButtonText: '确定',
                  lockScroll:false,
                })
              }else if(this.currentIndex == null){
                this.$alert('请选择收貨地址', '收貨地址', {
                  confirmButtonText: '确定',
                  lockScroll:false,
                  callback: () => {
                    window.scrollTo(0,0)
                  }
                });
              }else if((this.orderInformation.tel === null) || (this.orderInformation.tel === undefined) || (this.orderInformation.tel === "")){
                this.$alert('请填写收貨人联系电话', '联系电话', {
                  confirmButtonText: '确定',
                  lockScroll:false,
                  callback: () => {
                    window.scrollTo(0,0)
                  }
                });
              } else {
                //数据提交
                let loadingInstance = Loading.service({ fullscreen: true });
                   this.orderInformation.counselor_id == '' &&  (this.orderInformation.counselor_id = undefined)
                  placeOrder(this.orderInformation).then(res =>{
                    if (res){
                      loadingInstance.close()
                    }
                    //支付平台
                    var orderMsg = {
                      payment_method : res.data.meta.payment_method,
                      id : res.data.id
                    };
                    setLocalStorage('orderMsg',orderMsg);
                    sessionStorage.removeItem('purchaseData');
                    sessionStorage.removeItem('shopDataLists')
                    this.$router.push({
                      name:'OrderPayment',
                      query:{
                        id:res.data.id,
//                        surplus:this.user_money,
//                        is_counselor:this.is_counselor,
//                        use_points:this.usePoint
                     }
                    })
                  }).catch(err =>{
                    if (err){
                      loadingInstance.close()
                    }
                  });
              }
            }

        });
      },

/*      /!*门店自提提交订单*!/
      privateStore(){
        ifSignIn(this, () =>{
          if(this.purchaseData.length == 0){
            this.$message.warning('暫時沒有可提交的訂單哦');
            setTimeout( ()=> {
              this.$router.push({name:'ProductPage'});
            },1000)
          }else {
            if (this.a === false){
              this.$alert('请选择委託協議', '委託協議', {
                confirmButtonText: '确定',
                lockScroll:false,
              })
            }else if(this.orderInformation.store_id == ''){
              this.$message.warning('請選擇自提門店');
            }else {

            }
          }
        })
      },*/

      /*提交订单商品购买数据*/
      goodsId(){
        this.purchaseData.forEach((item) => {
          this.orderInformation.shopping_cart.push({goods_id:item.id,goods_number:item.num});
          return this.orderInformation;
        });
        this.orderInformation.shopping_cart = JSON.stringify(this.orderInformation.shopping_cart)
      },

      /*获取顾问列表*/
      getCounselors(counselor){
        counselors(counselor).then(res => {
          this.restaurants = res.data.data
          this.optionS = this.restaurants.slice(0,10)
        })
      },

      // 搜索用户信息
      remoteMethod(query) {
       /* if (query !== '') {
          this.loading = true
          setTimeout(() => {
            this.loading = false
            this.optionS = this.restaurants.filter(item => {
              if (item.phone.toLowerCase().indexOf(query.toLowerCase()) > -1) {
                return item.phone.toLowerCase().indexOf(query.toLowerCase()) > -1
              } else {
                return item.real_name.toLowerCase().indexOf(query.toLowerCase()) > -1
              }
            })
          }, 200)
        } else {
          this.optionS = this.restaurants.slice(0,10)
        }*/
      },

      /*获取协议内容*/
//      getAgreement(){
//        var params = {
//          article:4
//        }
//        journalismDetails(params).then(res =>{
//          this.agreement = (res.data.data)[0].title;
//          console.log(res.data.data)
//        })
//      },

      /*获取积分规则*/
      getPointRule(){
        pointRule().then(res =>{
          this.integralRule.max = res.data.max
          this.integralRule.amount = res.data.amount
          this.integralRule.min = res.data.min
          console.log('this.integralRule',this.integralRule)
        })
      },

      /*获取商品id和数量*/
      getParams(){
        var goods = '';
        this.purchaseData.forEach((item,index) =>{
          goods +=  'goods[' + index + '][goods_id]=' + item.id + '&' + 'goods[' + index + '][number]=' + item.num + '&'
          return goods
        })
//        var len = goods.length - 1
//        this.goods = goods.substr(0,len)
        this.goods = goods + 'user_id=' + this.user_id
      },

      /*获取已经拥有的优惠券*/
      getMyCouponsList(point){
          var par =  this.goods +'&point=' + point
        isMyCoupons(par).then(res =>{
          this.myCouponsList = res.data.data
//           this.myCouponsList.forEach((itm,idx) =>{
//            return this.activity[1].name[idx] = {label:itm.coupon_name}
//           })
// console.log(1,this.activity[1])
        })
      },

      /*获取满减活动*/
      getShoppingFullList(point){
        var par =  this.goods +'&point=' + point
        shoppingFull(par).then(res =>{
          this.shoppingFullList = res.data.data
//          console.log('shoppingFullList',this.shoppingFullList)
          // this.shoppingFullList.forEach((itm,idx) =>{
          //   return this.activity[0].name[idx] = {label:itm.reduction_name + +itm.worth.pay,details:itm}
          // })
          // console.log(1,this.activity[1])
        })
      },

      /*选择*/
      choice(){
          if (this.radioX == 1) {

          } else {

          }
      },

      /*活动选择*/
      choiceActivities(item,value){
          console.log(item,value)
      },

    },
    mounted(){
      //获取当前可用积分
      this.getInformation()
      //获取立即购买数据
      this.getImmediately();
/*      //获取商品参数
      this.getParams()*/
      //获取所有收货地址
      this.displayAddress();
      //提交订单商品购买数据
      this.goodsId();
      //判断是否登录
      ifSignIn(this, () =>{});
      //获取顾问列表
//      this.getCounselors();
      //协议内容
//      this.getAgreement();
      //积分使用规则
      this.getPointRule()
/*      //获取满减活动
      this.getMyCouponsList()
      //获取已经拥有的优惠券
      this.getShoppingFullList()*/
      window.scrollTo(0,0)
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
@import "../../css/settlementShop.less";

</style>



// WEBPACK FOOTER //
// src/pages/detailsPage/SettlementShop.vue